if (!customElements.get('ace-banner-jog')) {
  customElements.define('ace-banner-jog', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.animations?.forEach(animation => animation.cancel());
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.pauseButton = this.querySelector('.ace-banner-jog__pause');
      this.runners = [...this.querySelectorAll('.ace-banner-jog__runner')];
      this.banner = this.closest('.ace-member-notice');
      this.content = this.banner?.querySelector('.ace-member-notice__content');
      this.paused = false;
      this.focused = false;
      this.visible = false;
      this.animations = [];
      this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.desktop = window.matchMedia('(min-width: 990px)');
      this.update = () => {
        const running = this.visible && !this.paused && !this.focused && !this.motion.matches && this.desktop.matches && !document.hidden;
        this.toggleAttribute('data-running', running);
        this.animations.forEach(animation => running ? animation.play() : animation.pause());
      };
      this.measure = () => {
        const progress = this.animations[0] && this.duration ? (Number(this.animations[0].currentTime) || 0) / this.duration : 0;
        this.animations.forEach(animation => animation.cancel());
        this.animations = [];
        if (!this.desktop.matches || this.motion.matches || !this.banner || !this.content) { this.update(); return; }
        const banner = this.banner.getBoundingClientRect();
        const content = this.content.getBoundingClientRect();
        const start = 12;
        const leftEnd = Math.max(start, content.left - banner.left - 48);
        const rightStart = content.right - banner.left + 12;
        const end = Math.max(rightStart, banner.width - 84);
        const leftDistance = leftEnd - start;
        const distance = leftDistance + end - rightStart;
        if (distance <= 0) { this.update(); return; }
        const split = leftDistance / distance;
        this.duration = Math.max(4500, distance / 80 * 1000);
        const frames = [
          { transform: `translateX(${start}px)`, offset: 0 },
          { transform: `translateX(${leftEnd}px)`, offset: split },
          { transform: `translateX(${rightStart}px)`, offset: split },
          { transform: `translateX(${end}px)`, offset: 1 }
        ];
        this.runners.forEach((runner, index) => {
          const animation = runner.animate(frames, { duration: this.duration, iterations: Infinity, easing: 'linear' });
          animation.pause();
          animation.currentTime = (progress % 1) * this.duration + index * Math.min(44, distance / 3) / distance * this.duration;
          this.animations.push(animation);
        });
        this.update();
      };
      this.pauseButton.addEventListener('click', () => {
        this.paused = !this.paused;
        this.toggleAttribute('data-paused', this.paused);
        this.pauseButton.setAttribute('aria-pressed', String(this.paused));
        this.pauseButton.setAttribute('aria-label', this.paused ? this.pauseButton.dataset.playLabel : this.pauseButton.dataset.pauseLabel);
        this.update();
      }, options);
      this.banner?.addEventListener('focusin', () => { this.focused = true; this.update(); }, options);
      this.banner?.addEventListener('focusout', event => { this.focused = Boolean(event.relatedTarget && this.banner.contains(event.relatedTarget)); this.update(); }, options);
      document.addEventListener('visibilitychange', this.update, options);
      this.motion.addEventListener('change', this.measure, options);
      this.desktop.addEventListener('change', this.measure, options);
      this.observer = new IntersectionObserver(entries => {
        this.visible = entries[0].isIntersecting;
        this.update();
      });
      this.observer.observe(this);
      this.resizeObserver = new ResizeObserver(this.measure);
      if (this.banner) this.resizeObserver.observe(this.banner);
      if (this.content) this.resizeObserver.observe(this.content);
      this.measure();
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.observer?.disconnect();
      this.resizeObserver?.disconnect();
      this.animations?.forEach(animation => animation.cancel());
    }
  });
}
